import { AppSubjectEnum } from '../../../shared/modules/authz/enums/app-subject.enum';
import { CaslSubject } from '../../../shared/modules/authz/decorators/casl-subject.decorator';
import { BaseStatsDto } from '../../../shared/modules/base/dtos/base-stats.dto';

/**
 * Filebox stats DTO
 */
@CaslSubject(AppSubjectEnum.FILEBOX)
export class FileboxStatsDto extends BaseStatsDto {
	pending!: number;
	leased!: number;
	synchronized!: number;
	failed!: number;
	deadLettered!: number;
}
